const getCurrentHref = () => {
  if (typeof window !== 'undefined' && window.location && window.location.href) {
    return window.location.href;
  }
  return '';
};

const decodeValue = (value) => {
  try {
    return decodeURIComponent(value);
  } catch (error) {
    return value;
  }
};

const normalizeId = (value) => {
  if (value === undefined || value === null) return '';
  return decodeValue(String(value)).trim();
};

const getFirstQueryValue = (query, names) => {
  for (let i = 0; i < names.length; i += 1) {
    const value = normalizeId(query.get(names[i]));
    if (value) return value;
  }
  return '';
};

const pickQuery = (query, names) => {
  const picked = {};
  for (let i = 0; i < names.length; i += 1) {
    const name = names[i];
    const value = normalizeId(query.get(name));
    if (value) picked[name] = value;
  }
  return Object.keys(picked).length ? picked : undefined;
};

const getHashForumUrl = (hash) => {
  if (!hash || hash.indexOf('#/forum') !== 0) return null;
  const raw = hash.slice(1);
  const queryIndex = raw.indexOf('?');
  const path = queryIndex >= 0 ? raw.slice(0, queryIndex) : raw;
  const search = queryIndex >= 0 ? raw.slice(queryIndex + 1) : '';
  return {
    path,
    query: new URLSearchParams(search),
  };
};

const parseForumUrl = (href, currentHref = getCurrentHref()) => {
  if (!href) return null;
  try {
    const baseHref = currentHref || getCurrentHref();
    const url = baseHref ? new URL(href, baseHref) : new URL(href);
    const hashUrl = getHashForumUrl(url.hash);
    if (hashUrl) return hashUrl;
    return {
      path: url.pathname,
      query: url.searchParams,
    };
  } catch (error) {
    return null;
  }
};

const getPathSegments = (path) =>
  String(path || '')
    .split('?')[0]
    .replace(/\/+$/, '')
    .split('/')
    .filter(Boolean)
    .map(decodeValue);

const resolvePostRoute = (segments, query) => {
  const postId = normalizeId(segments[2]) || getFirstQueryValue(query, ['postId', 'postsId']);
  if (!postId) return null;
  return {
    name: 'forum-post-detail',
    params: { postId },
    query: pickQuery(query, ['focusComment']),
  };
};

const resolveAssembleRoute = (segments, query) => {
  const assembleId = normalizeId(segments[2]) || getFirstQueryValue(query, ['assembleId', 'id']);
  if (!assembleId) return null;
  return {
    name: 'forum-assemble',
    params: { assembleId },
    query: pickQuery(query, ['title']),
  };
};

const resolveGroupRoute = (segments, query) => {
  const groupId = normalizeId(segments[2]) || getFirstQueryValue(query, ['groupId', 'forumId']);
  if (!groupId) return null;
  return {
    name: 'forum-group',
    params: { groupId },
  };
};

const resolveSearchRoute = (query) => {
  const routeQuery = {};
  const groupId = getFirstQueryValue(query, ['groupId', 'forumId']);
  if (groupId) routeQuery.groupId = groupId;
  const title = getFirstQueryValue(query, ['title', 'keyword', 'keywords']);
  if (title) routeQuery.title = title;
  return {
    name: 'forum-search',
    query: Object.keys(routeQuery).length ? routeQuery : undefined,
  };
};

export const resolveForumContentLink = (href, currentHref) => {
  const parsed = parseForumUrl(href, currentHref);
  if (!parsed) return null;
  const segments = getPathSegments(parsed.path);
  if (segments[0] !== 'forum') return null;

  const page = segments[1] || '';
  if (page === 'post' && segments[2] === 'create') return { name: 'forum-post-create' };
  if (page === 'post') return resolvePostRoute(segments, parsed.query);
  if (page === 'postDetail') return resolvePostRoute(segments, parsed.query);
  if (page === 'assemble') return resolveAssembleRoute(segments, parsed.query);
  if (page === 'postSet') return resolveAssembleRoute(segments, parsed.query);
  if (page === 'group') return resolveGroupRoute(segments, parsed.query);
  if (page === 'detail') return resolveGroupRoute(segments, parsed.query);
  if (page === 'square' || page === 'list') return { name: 'forum-square' };
  if (page === 'search' || page === 'search-legacy') return resolveSearchRoute(parsed.query);
  if (page === 'profile' || page === 'profile-legacy') return { name: 'forum-profile' };
  if (page === 'edit-profile' || page === 'editProfile') return { name: 'forum-edit-profile' };
  return null;
};
